import { render, staticRenderFns } from "./Telemarketing.vue?vue&type=template&id=d1b863de&scoped=true&"
import script from "./Telemarketing.vue?vue&type=script&lang=js&"
export * from "./Telemarketing.vue?vue&type=script&lang=js&"
import style0 from "./Telemarketing.vue?vue&type=style&index=0&id=d1b863de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b863de",
  null
  
)

export default component.exports